import {
  LuCircleCheck,
  LuRotateCcw,
  LuBuilding2,
  LuHash,
  LuCalendarDays,
} from "react-icons/lu";

type CertifiedViewBaseProps = {
  leaName: string;
  vendorNumber: string;
  certificationCycle: string;
  certifierName: string;
  certifiedDate?: string;
};

type CertifiedViewProps = CertifiedViewBaseProps &
  (
    | { showDecertify: true; onDecertify: () => void }
    | { showDecertify: false; onDecertify?: never }
  );

export default function CertifiedView({
  leaName,
  vendorNumber,
  certificationCycle,
  certifierName,
  certifiedDate,
  showDecertify,
  onDecertify,
}: CertifiedViewProps) {
  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{ padding: "3rem 1.5rem 2rem" }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle mb-3"
        style={{
          width: 80,
          height: 80,
          backgroundColor: "#d1fae5",
        }}
      >
        <LuCircleCheck size={40} color="#16a34a" aria-hidden="true" />
      </div>
      {/* Certified heading */}
      <h4
        className="mb-2"
        style={{
          fontWeight: 700,
          fontSize: "1.5rem",
          color: "#0f172a",
        }}
      >
        Certified
      </h4>

      <p
        className="mb-4"
        style={{
          color: "#374151",
          fontSize: "1rem",
          textAlign: "center",
        }}
      >
        Data certified by <strong>{certifierName}</strong>
        {certifiedDate ? ` on ${certifiedDate}.` : "."}
      </p>

      <div
        className="d-flex gap-3 mb-4"
        style={{ width: "100%", maxWidth: 720 }}
      >
        {[
          { icon: LuBuilding2, label: "LEA NAME", value: leaName },
          { icon: LuHash, label: "VENDOR NUMBER", value: vendorNumber },
          {
            icon: LuCalendarDays,
            label: "CERTIFICATION CYCLE",
            value: certificationCycle,
          },
        ].map(({ icon: Icon, label, value }) => (
          <div
            key={label}
            className="d-flex flex-column align-items-center text-center flex-fill"
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "0.375rem 0.375rem 0px 0px",
              padding: "1.25rem 1rem",
              backgroundColor: "#f8fafc",
            }}
          >
            <Icon
              size={24}
              color="#64748b"
              style={{ marginBottom: "0.5rem" }}
              aria-hidden="true"
            />
            <div
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "0.25rem",
              }}
            >
              {label}
            </div>
            <div
              style={{
                fontSize: "1.05rem",
                fontWeight: 600,
                color: "#0f172a",
              }}
            >
              {value}
            </div>
          </div>
        ))}
      </div>

      {showDecertify && (
        <button
          type="button"
          className="btn d-flex align-items-center justify-content-center gap-2"
          onClick={onDecertify}
          aria-label="Decertify submission"
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#a3560a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#b45309";
          }}
          onFocus={(e) => {
            e.currentTarget.style.backgroundColor = "#a3560a";
            e.currentTarget.style.outline = "2px solid #b45309";
            e.currentTarget.style.outlineOffset = "2px";
          }}
          onBlur={(e) => {
            e.currentTarget.style.backgroundColor = "#b45309";
            e.currentTarget.style.outline = "none";
          }}
          style={{
            backgroundColor: "#b45309",
            color: "#ffffff",
            border: "none",
            borderRadius: "0.5rem",
            padding: "0.625rem 2rem",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}
        >
          <LuRotateCcw size={16} aria-hidden="true" />
          Decertify
        </button>
      )}
    </div>
  );
}
